<template>
  <div>
    <debtor-table-filter
        :filter.sync="filter"
        @change="getItemsWithLoading"
        :mkos="mkos"
    />
    <v-data-table
        disable-pagination
        hide-default-footer
        :options.sync="options"
        :headers="headers"
        :items="items">
      <template v-slot:body="{items}">
        <tbody>
        <tr :key="item.credit_number" v-for="(item,i) in items">
          <td>{{ getNumber(i) }}</td>
          <td>{{ item.credit_number }}</td>
          <td>{{ item.full_name }}</td>
          <td>{{ item.old_amount|money }}</td>
          <td>{{ item.period }}</td>
          <td>
            <v-chip :color="item.current_debt > 0 ? 'pink' : ''" :text-color="item.current_debt > 0 ? 'white' : ''"
                    class="ma-2" label>
              {{ (Math.ceil(item.current_debt))|money }}
            </v-chip>
          </td>
          <td>{{ item.created_at }}</td>
          <td>{{ item.start_date }} - {{ item.finish_date }}</td>
          <td>{{ item.turn_autopayment ? 'Да' : 'Нет' }}</td>
          <td><span :class="statusColor(item.status)">{{ item.status_name }}</span></td>
          <td>
            <v-btn @click="$router.push({name: 'credit-item', params: {id: item.id}})" class="action-btn"
                   color="success">
              <v-icon small>fas fa-eye</v-icon>
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-pagination
        v-if="lastPage > 1"
        v-model="options.page"
        :length="lastPage"
    ></v-pagination>
  </div>
</template>

<script>

import {debounce} from "@/utils/pureFunctions";
import DebtorTableFilter from "@/components/debtor/tableFilter";

export default {
  components: {DebtorTableFilter},
  data() {
    return {
      headers: [
        {text: '№', value: 'number', sortable: false},
        {text: 'Кредит №', value: 'credit_number', sortable: false},
        {text: 'Ф.И.О', value: 'full_name', sortable: false},
        {text: 'Сумма', value: 'amount', sortable: false},
        {text: 'Срок (мес.)', value: 'period', sortable: false},
        {text: 'Задолженность', value: 'current_debt', sortable: false},
        {text: 'Дата создания', value: 'created_at', sortable: false},
        {text: 'Дата', value: 'date', sortable: false},
        {text: 'Автосписание', value: 'turn_autopayment', sortable: false},
        {text: 'Статус', value: 'status', sortable: false},
        {text: 'Действие', value: 'action', sortable: false}
      ],
      mkos: [],
      items: [],
      options: {
        page: 1
      },
      filter: {
        name: null,
        from: null,
        to: null,
        debts: null,
        passport: null
      },
      lastPage: 0,
      current: 1
    }
  },
  methods: {
    async getItems() {
      let params = {
        ...this.options,
        ...this.filter
      }
      try {
        const {data: {data, links: {last_page, current_page}}} = await this.$http.get('admin/credits/debtors', {
          params
        })
        this.items = data
        this.lastPage = last_page
        this.current = current_page;
      } catch (e) {
        this.$setResponseError({error: e})
      }
    },
    async getItemsWithLoading() {
      this.$showLoading()
      await this.getItems()
      this.$clearLoading()
    },
    getNumber(i) {
      return (this.current - 1) * 30 + i + 1;
    },
    statusColor(status) {
      switch (status) {
        case 0:
          return 'red--text';
        case 2:
          return 'green--text';
        case 3:
          return 'orange--text';
        case 5:
          return 'orange--text'
      }
    },
  },
  async created() {
    const {page} = this.$route.query
    if (page && !isNaN(page)) this.options.page = +page
    this.$showLoading()
    await this.getItems()
    this.$clearLoading()
    this.mkos = await this.$store.dispatch('getMkos')
  }
}
</script>
